export default "__VITE_ASSET__aea079d6__"